import React, {Component} from 'react';
import {NavBar, Toast,Modal} from 'antd-mobile';
import {passengers} from "../../../service/shiftService";
import {fakeConverse} from "../../../service/homeService";
import {connect} from "react-redux";
import "./style.less";
const noPassenger = require('../../../common/image/noRider.png');
@connect(
    state => ({userInfo: state.userInfo}),
)

export default class PassengerList extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            data:[],
            showModal:false,
            orderId:'',
        };

    }

    componentDidMount() {
     this.getPassengerList();
    }
    getPassengerList = () =>{
        let params = {
            token:this.props.userInfo.token,
            "data":{
              "shiftId":this.props.location.state.id
            }
          }
          Toast.loading("正在加载",0);
          passengers(params).then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                  Toast.hide();
                  this.setState({
                      data:res.data.data
                  })
                }
                else if (res.data.code === '1401') {
                  document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
              console.log(error);
          });

    }
    callPhone =(id)=>{
        this.setState({
            showModal:true,
            orderId:id,
        })
        
    }
    number=(id)=>{ 
        console.log(id)
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "id":id,
                orderSource:6,
            }
        };
        fakeConverse(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                window.location.href = "tel://" +  res.data.data.middleNumber;
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
  
    render() {
        return (
            <div className="passengerList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >乘客详情</NavBar>
                {
                    this.state.data.length > 0 ? this.state.data.map((res,i) => (
                        <div className="cardBox" style={ res.isEndorse === 0 ? null : {
                            backgroundColor: '#FFFBF5',
                        }} key={i}>
                            {res.isEndorse === 1 ? <div className="change">改签订单</div> :(res.isEndorse === 2 ? <div className="special">特殊改签订单</div> :null)}
                            <div className="title">
                                <span>{res.seatNum}</span>
                                {res.isChild === 1 ? <span className="child">儿童订单</span>:null}
                                <span></span>
                                {res.status == 11 ? null :  <span className="color" onClick={()=>this.callPhone(res.id)}>{res.phone}</span>}
                                <span>￥{res.actualPrice}</span></div>
                            <div className="start"><i className="icon iconfont icondaixiadanchufadi"></i>{res.startAddress}</div>
                            <div className="end"><i className="icon iconfont icondaixiadanmudedi"></i>{res.endAddress}</div>
                        </div>
                    )) : (
                        <div className="noData">
                            <img src={noPassenger}/>
                            <p>暂无乘客信息</p>
                        </div>
                    )
                }
                <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '否', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.number(this.state.orderId) } }]}
                >
                    <div className="modalTitle">
                        <div>是否确认拨打电话？</div>
                        {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                    </div>
                </Modal>     
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Shift/PassengerList/index.js